import { useMemo, useState } from "react";
import AttachmentsPanel from "components/taskdetails-remake/panels/attachments/AttachmentsPanel.component";
import AttachmentsPanelHeader from "components/taskdetails-remake/panels/attachments/detached/AttachmentsPanelHeader.component";
import {
    getAttachmentsLoadingStatus,
    isDocumentPreviewDetached,
    getTaskAttachments,
    getTaskDetails, getDocumentPreviewStatus,
} from "components/store/application.reducers";
import { useDispatch, useSelector } from "react-redux";
import { documentPreviewReattach } from "components/taskdetails-remake/taskDetails.action";
import AttachmentsPanelInWaiting
    from "components/taskdetails-remake/panels/attachments/detached/AttachmentsPanelInWaiting.component";
import { DOCUMENT_PREVIEW_STATUS } from "utils/constants";
import AttachmentsPanelUnavailable from "components/taskdetails-remake/panels/attachments/detached/AttachmentsPanelUnavailable.component";
import NewWindow from "components/taskdetails-remake/panels/attachments/detached/NewWindow";
import AsyncTaskActionExecutor from "components/taskdetails-remake/panels/attachments/detached/AyncTaskExecutorDetached.component";


export function DocumentPreviewWindow({translate, onKeyPress}) {
    const dispatch = useDispatch();
    const [popupRef, setPopupRef] = useState(null);
    const attachments = useSelector(getTaskAttachments);
    const loadingStatus = useSelector(getAttachmentsLoadingStatus);
    const taskDetails = useSelector(getTaskDetails);
    const isPreviewDetached = useSelector(isDocumentPreviewDetached);
    const previewStatus = useSelector(getDocumentPreviewStatus);
    const width = parseInt(window.localStorage.getItem(`@@grid/attachments-width`)) || 1200;
    const height = document?.body.clientHeight || 800;

    function onOpen(nextPopupRef: any) {
        setPopupRef(nextPopupRef);
        window.onbeforeunload = onUnload;
    }

    function onUnload() {
        dispatch(documentPreviewReattach());
        setPopupRef(null);
        window.onbeforeunload = null;
    }

    const memoizedOptions = useMemo(
        () => ({
            ownerDocument: popupRef ? popupRef.document : undefined,
        }),
        [popupRef],
    );

    const getAttachmentsPanelComponent = () => {
        if (!memoizedOptions.ownerDocument) {
            return <AttachmentsPanelInWaiting />;
        }
        switch (previewStatus) {
            case DOCUMENT_PREVIEW_STATUS.WAITING:
                return <AttachmentsPanelInWaiting />;
            case DOCUMENT_PREVIEW_STATUS.UNAVAILABLE:
                return <AttachmentsPanelUnavailable />;
            case DOCUMENT_PREVIEW_STATUS.AVAILABLE:
                return <div className={"d-flex flex-column detached w-100 h-100"}>
                    <AttachmentsPanelHeader />
                    <AttachmentsPanel attachments={attachments}
                                      loadingStatus={loadingStatus}
                                      taskDetails={taskDetails}
                                      translate={translate}
                                      ownerDocument={memoizedOptions}
                    />
                    <AsyncTaskActionExecutor />
                </div>;
        }
    };


    return (
        <div>{isPreviewDetached && <NewWindow features={{ width: width, height: height }}
                                              title={" Approval | Visma.net"}
                                              name={"DocumentPreviewWindow"}
                                              onOpen={onOpen}
                                              onKeyPress={onKeyPress}
                                              onUnload={onUnload}>
            {getAttachmentsPanelComponent()}
        </NewWindow>
        }</div>
    );
}

export default DocumentPreviewWindow;